import { DeepPartial } from 'utility-types'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from 'revamp/reusable-components/tooltip/tooltip'
import classNames from 'classnames'
import BulbIconSvg from '../technical-analysis/bulb-svg'
import Gauge, {
  TGaugeProps,
} from '@/components/USStocks/technical-analysis/gauge'
import Info from '@/assets/common/info.inline.svg'
import Link from '@/components/Common/Link'
import INGauge from '@/components/Stocks/Widgets/INGauge'
import InStockL2Heading from '@/components/Stocks/Pages/InStockDetailPageV2/InL2Heading'

type Props = {
  data?: DeepPartial<TApiResponseTechnicalWidgetSlice>
  parentClass?: string
}

type TApiResponseTechnicalWidgetSlice = {
  heading: string
  summary_img: string
  icon: string
  description: string
  cta: {
    text: string
    relative_url: string
  }
  tooltip: string
  indicators?: string[]
  pod?: 'INDStocks'
}

export default function TechnicalAnalysisWidget(props: Props) {
  const { data, parentClass = 'bg-brand-white rounded-xl p-6' } = props

  if (!data) {
    return null
  }

  return (
    <section className={classNames(parentClass)}>
      <div className="flex items-center">
        {data.heading && <InStockL2Heading heading={data.heading} />}
        {data.tooltip && (
          <div className="ml-auto">
            <Tooltip offset={16}>
              <TooltipTrigger>
                <Info className="ml-auto h-4 w-4" />
              </TooltipTrigger>

              <TooltipContent>
                <div
                  className="bg-brand-white shadow-two min-w-[200px] max-w-xs rounded-xl p-4 text-xs"
                  dangerouslySetInnerHTML={{
                    __html: data.tooltip,
                  }}
                />
              </TooltipContent>
            </Tooltip>
          </div>
        )}
      </div>

      <div className=" mt-6 flex max-w-xl flex-col items-center lg:flex-row">
        {/* gauge */}
        {data.summary_img && (
          <div>
            {data.pod === 'INDStocks' ? (
              <INGauge
                radius={100}
                percent={100}
                type={data.summary_img as TGaugeProps['type']}
              />
            ) : (
              <Gauge
                radius={100}
                percent={100}
                type={data.summary_img.toLowerCase() as TGaugeProps['type']}
              />
            )}
          </div>
        )}

        {/* text */}
        <div className="bg-orange-tertiary flex max-w-xs items-center gap-3 rounded-xl p-3 md:ml-auto lg:ml-28">
          <div className="flex-shrink-0">
            <BulbIconSvg />
          </div>
          <p className="text-sm">{data.description}</p>
        </div>
      </div>

      {data.cta?.text && data.cta.relative_url && (
        <div className="mt-5 w-full text-center lg:mt-1">
          <Link
            className=" text-brand-blue-azureRadiance inline-block w-full px-6 py-2 lg:w-fit"
            href={data.cta.relative_url}
          >
            {data.cta.text}
          </Link>
        </div>
      )}
    </section>
  )
}
